import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, User } from 'lucide-react';
import { Button } from './ui/button';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AthleteContextHeader = ({ athleteId, moduleName }) => {
  const navigate = useNavigate();
  const [athleteName, setAthleteName] = useState('');

  useEffect(() => {
    if (athleteId) {
      axios.get(`${API}/athletes/${athleteId}`)
        .then(res => setAthleteName(res.data.full_name))
        .catch(() => setAthleteName('Unknown'));
    }
  }, [athleteId]);

  if (!athleteId) return null;

  return (
    <div className="bg-emerald-50 dark:bg-emerald-900/20 border-b border-emerald-200 dark:border-emerald-800 px-6 py-3 -mx-6 -mt-6 lg:-mx-8 lg:-mt-8 mb-6 flex items-center justify-between" data-testid="athlete-context-header">
      <div className="flex items-center gap-3">
        <Button variant="outline" size="sm" onClick={() => navigate(`/athlete/${athleteId}/360`)}
          className="h-8 border-emerald-300 dark:border-emerald-700" data-testid="back-to-profile-btn">
          <ArrowLeft className="w-4 h-4 mr-1" /> Back to Profile
        </Button>
        <div className="h-5 w-px bg-emerald-300 dark:bg-emerald-700" />
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-full bg-emerald-200 dark:bg-emerald-800 flex items-center justify-center">
            <User className="w-4 h-4 text-emerald-700 dark:text-emerald-300" />
          </div>
          <span className="font-semibold text-emerald-900 dark:text-emerald-100" data-testid="athlete-context-name">
            {moduleName} &mdash; {athleteName || 'Loading...'}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AthleteContextHeader;
